import React, { useEffect } from "react";
// import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
// import NavBar from "components/NavBar";
import { ProtectedRouteProps } from "types/ProtectedRoute/ProtectedRoute.interface";
import NavigationHeader from "components/NavigationHeader";
import { useMsal } from "@azure/msal-react";
import { getMSToken } from "services/auth-actions";
// import { useAppSelector } from "hooks";

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  // get the token from local storage
  // const token = localStorage.getItem("token");
  // const navigate = useNavigate();

  // // if token is not present, redirect to login page
  // if (!token) {
  //   navigate("/");
  // }
  const { instance } = useMsal();
  // const authSelector = useAppSelector((state) => state.auth);
  useEffect(() => {
    const getTokenOnRender = async () => {
      await getMSToken(instance);
    };
    getTokenOnRender();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="flex flex-col gap-24">
      <div>
        <NavigationHeader />
      </div>
      <div>{children}</div>
    </div>
  );
}
ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
};
